import Base from './Endpoint/Base.es6';
(() => {
    class Endpoint extends Base {
        constructor(endpoint) {
            super();
            this.cache      = false; // If this endpoint is going to be using the storage
            this.keyable    = false; // If this api has an option to call items by a key (id)
            this.endpoint   = endpoint;
            this.callbacks  = [];
        }

        /* GETTERS */
        get response() {
            // Call API when result ha not been loaded yet
            return (async () => {
                if (!this._response) {
                    this.response = await App.Interface.Api.promise(this.endpoint, this.params, {cache: this.cache, async: true});
                    this.setTimestamp();
                    this.Observer.notify();
                }
                return this._response;
            })();
        }

        set response(response) {
            this._response = this.filter(response);
        }

        get get() {
            return (async () => {
                return await this.response;
            })();
        }

        async getById(id, related = true) {
            if (id) {
                // Find id as string or int
                let item = (await this.get).find(items => items['id'] == id);
                // lets get item per ID if not available in bundle
                if (id && !item && this.keyable === 'id') {
                    let apiItem = await App.Interface.Api.promise([this.endpoint, id].join('/'), {}, {cache: this.cache, async: true});
                    if (apiItem?.status !== 404) {
                        this._response.push(this.applyModel(apiItem, 'injected'));
                        return this.getById(id);
                    }
                    return undefined;
                }
                return related ? item : Object.assign({}, item);
            }
        }

        async getByUid(uid) {
            return await this.getBy('uid', uid);
        }

        /**
         * find a occurrence by identifier
         * @param identifier
         * @returns {*}
         */
        async getByIdentifier(identifier) {
            return await this.getBy('identifier', identifier);
        }

        /**
         * all rounder to find occurrence by different fields
         * @param field
         * @param value
         * @returns object
         */
        async getBy(field, value) {
            if (typeof this.get === 'object')
                return Object.values(await this.get).find(items => items[field] === value);
            return await this.get.find(items => items[field] === value);
        }

        /**
         * by the position key of the requested array [0: {}, 1: {}..]
         * !Not a field named key
         * @param key
         * @returns {*}
         */
        async getByKey(key) {
            return await this.get[key];
        }

        async getFirst() {
            return await this.get[0];
        }
    }
    App.Entities.Endpoint = Endpoint;
})();
